import React from "react";
import { logoUrl } from "@/context/SettingsContext";

/** Vast logo linksboven op elk document: altijd dezelfde plaats en grootte. */
export default function PrintLogo({ camp, testid = "print-logo" }) {
  return (
    <img src={logoUrl(camp, "main")} alt={camp?.camp_name || ""} data-testid={testid}
      className="h-16 w-auto max-w-[220px] object-contain shrink-0" />
  );
}
